import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: grid;
  gap: ${theme.spacing.md};
  grid-template-columns: 3fr 2fr 1fr;

  .partners-full,
  .partners,
  .commercial,
  .cancel,
  .cost {
    display: grid;
  }

  .partners-full {
    grid-column: 1 / 3;
  }
  .cancel {
    grid-column: 2 / 3;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 2fr 1fr;
    .partners-full,
    .partners,
    .commercial,
    .cancel,
    .cost {
      grid-column: 1 / 3;
    }
  }
`
